import React from 'react';

const PasswordWidget = ({ 
  password, 
  confirmPassword, 
  onChange, 
  namePassword = "contrasena", 
  nameConfirm = "confirmarContrasena" 
}) => {
  
  // Validaciones
  const validations = {
    minLength: password.length >= 8,
    hasNumber: /\d/.test(password),
    hasUpper: /[A-Z]/.test(password),
    hasSpecial: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password),
    match: password && confirmPassword && password === confirmPassword
  };

  return (
    <div className="space-y-4">
      {/* Input Contraseña */}
      <div className="flex flex-col">
        <label className="mb-1 flex items-center font-medium text-gray-700">
          Contraseña:
          <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="password"
          name={namePassword}
          value={password}
          onChange={onChange}
          placeholder="Ingrese su contraseña"
          className="p-2 border border-gray-300 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
          required
          autoComplete="new-password"
        />
        
        {/* Lista de Requisitos */}
        <div className="mt-2 text-sm bg-gray-50 p-3 rounded-md border border-gray-100">
          <p className="font-semibold text-gray-700 mb-1">La contraseña debe contener:</p>
          <ul className="pl-5 space-y-1">
            <li className={`flex items-center ${validations.minLength ? "text-green-600 font-medium" : "text-gray-500"}`}>
              <span className="mr-2">{validations.minLength ? "✓" : "○"}</span> Mínimo 8 caracteres
            </li>
            <li className={`flex items-center ${validations.hasNumber ? "text-green-600 font-medium" : "text-gray-500"}`}>
              <span className="mr-2">{validations.hasNumber ? "✓" : "○"}</span> Al menos un número
            </li>
            <li className={`flex items-center ${validations.hasUpper ? "text-green-600 font-medium" : "text-gray-500"}`}>
              <span className="mr-2">{validations.hasUpper ? "✓" : "○"}</span> Al menos una letra mayúscula
            </li>
            <li className={`flex items-center ${validations.hasSpecial ? "text-green-600 font-medium" : "text-gray-500"}`}>
              <span className="mr-2">{validations.hasSpecial ? "✓" : "○"}</span> Carácter especial (!@#$...)
            </li>
          </ul>
        </div>
      </div>

      {/* Input Confirmar */}
      <div className="flex flex-col">
        <label className="mb-1 flex items-center font-medium text-gray-700">
          Confirmar contraseña:
          <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="password"
          name={nameConfirm}
          value={confirmPassword}
          onChange={onChange}
          placeholder="Confirme su contraseña"
          className={`p-2 border rounded w-full focus:outline-none transition-colors ${
            confirmPassword
              ? validations.match 
                ? "border-green-500 bg-green-50 focus:ring-green-200" 
                : "border-red-500 bg-red-50 focus:ring-red-200"
              : "border-gray-300 focus:ring-2 focus:ring-blue-500"
          }`}
          required
        />
        {confirmPassword && (
          <p className={`text-sm mt-1 font-medium ${validations.match ? "text-green-600" : "text-red-500"}`}>
            {validations.match ? "✓ Las contraseñas coinciden" : "✕ Las contraseñas no coinciden"}
          </p>
        )}
      </div>
    </div>
  );
};

export default PasswordWidget;